import { DigitalHumanVideo } from '../DigitalHumanVideo';
import { dhVideoAspect } from '../../store/widget-store';

/**
 * 数字人展示舞台 —— 桌面端占大弹窗左半屏,移动端为全屏背景(见 widget.css .dcs-dh-stage)。
 * 仅作布局容器;视频切换逻辑沿用既有 DigitalHumanVideo(双 video cross-fade,订阅 videoState)。
 * 挂在 ImmersiveShell 内,welcome / chat 两个视图共用同一实例 —— 切换视图时视频 DOM 不卸载、不黑屏。
 */
export function DigitalHumanStage() {
  // 已知视频真实宽高比时,加 is-fitted 并以 CSS 变量传比例:桌面端据此收窄左框贴合视频、消除两侧留白;
  // 走 CSS 变量而非直接 inline aspect-ratio,移动端媒体查询才能干净覆盖(不被 inline 样式压过)。
  const aspect = dhVideoAspect.value;
  return (
    <div
      class={`dcs-dh-stage${aspect ? ' is-fitted' : ''}`}
      style={aspect ? { '--dcs-dh-aspect': String(aspect) } : undefined}
    >
      <DigitalHumanVideo />
    </div>
  );
}
